import React, { FunctionComponent } from 'react';

const SchoolArticles: FunctionComponent = () => <div>This will be school rankings page.</div>;

export default SchoolArticles;
